import { AttachmentIcon } from "@chakra-ui/icons";
import { Button } from "@chakra-ui/react";
import { useRef } from "react";

function FileUpload({ onFileSelect }) {
  const inputRef = useRef(null);

  const handleClick = () => {
    inputRef.current?.click();
  };

  const handleChange = (event) => {
    const files = Array.from(event.target.files);
    if (files.length > 0) {
      onFileSelect(files);
    }

    // Reset the input so selecting the same file again still triggers change
    event.target.value = "";
  };

  return (
    <>
      <input
        type="file"
        ref={inputRef}
        multiple
        style={{ display: "none" }}
        onChange={handleChange}
      />
      <Button
        leftIcon={<AttachmentIcon />}
        colorScheme="gray"
        onClick={handleClick}
      >
        Upload
      </Button>
    </>
  );
}

export default FileUpload;
